module.exports = __webpack_public_path__ + "static/media/btn_android_en.d5efd69f.svg";